import { FC } from 'react';

const InteractiveLoginPickerTab: FC = () => {
    return (
        <div className="border border-sf-gray-100 rounded-lg w-full h-fit px-6 py-4 flex gap-2 items-center">
            Interactive login attempts using this account will trigger a policy violation in Silverfort (based on the
            risk indicator Service Account Interactive Login).
        </div>
    );
};

export default InteractiveLoginPickerTab;
